import React from 'react'
import {useSpring, animated} from 'react-spring/web.cjs'
import {Box, Grid, Hidden} from '@material-ui/core'

const calc = (x: number, y: number) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const c = (x: any | undefined) => `center ${-Math.round(x) / 40 + 35}%`
const b = (x: any | undefined) => `translateX(${x / 30}px`

const Two = () => {
  const [propsSpring, set] = useSpring(() => ({xy: [0, 0], config: {mass: 1, tension: 400, friction: 50}}))

  return (
    <Grid container justify={'space-between'} alignItems={'center'} onMouseMove={({clientX: x, clientY: y}) => set({xy: calc(x, y)})}>
      <Box className={'parallax_container'}>
        <Hidden smDown>
          <animated.img className={'two_b1'} src={`/img/page2/b1.png`} style={{transform: propsSpring.xy.interpolate(b)}} />
          <img className={'two_b2'} src={`/img/page2/b-other.png`} alt={''} />
        </Hidden>
        <Hidden mdUp>
          <img className={'two_b1'} src={`/img/page2/b1.png`} alt={''} />
          <img className={'two_b2'} src={`/img/page2/b-other.png`} alt={''} />
        </Hidden>
      </Box>

      <Hidden smDown>
        <Grid item xs={11} md={5}>
          <animated.div className={'c'} style={{backgroundPosition: propsSpring.xy.interpolate(c)}} />
        </Grid>
      </Hidden>

      <Grid item xs={12} md={7} style={{height: '90%'}}>
        <Box pl={{xs: 0, md: 20}} height={'100%'}>
          <Grid container className={'paper'} justify={'center'} alignItems={'center'} style={{height: '100%'}}>
            <Grid item xs={12} sm={6}>
              <Box my={4}>
                <img src="/img/logo.png" width={'100%'} height={'auto'} alt="AURA" />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className={'text'}>
                <span>Мы&nbsp;-&nbsp;совокупность энергии мышления, жизненных приоритетов, устремлений и&nbsp;особое состояние&nbsp;духа</span>
                <br />
                <br />
                <span>
                  Мы&nbsp;-&nbsp;надежная и&nbsp;опытная команда, которая создает и&nbsp;реализует индивидуальные маркетинговые решения для&nbsp;своих
                  клиентов
                </span>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  )
}

export default Two
